
import React from 'react';
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from '@/components/ui/carousel';
import { Skeleton } from '@/components/ui/skeleton';
import RecipeCard from '@/components/RecipeCard';

interface ExploreSectionProps {
  title: string;
  icon: any;
  recipes: any[];
  className?: string;
  isLoading?: boolean;
}

const ExploreSection: React.FC<ExploreSectionProps> = ({ 
  title, 
  icon: Icon, 
  recipes,
  className = "",
  isLoading = false
}) => (
  <div className={`mb-12 ${className}`}>
    <div className="flex items-center gap-2 mb-6">
      <Icon className="h-6 w-6 text-vegana-primary" />
      <h2 className="text-2xl font-semibold text-vegana-primary">{title}</h2>
      {isLoading && (
        <div className="ml-2 text-sm text-gray-500">Cargando...</div>
      )}
    </div>
    
    <Carousel
      opts={{
        align: "start",
        loop: true,
      }}
      className="w-full relative"
    >
      <CarouselContent className="-ml-4">
        {isLoading ? (
          // Show skeleton loaders while loading
          Array.from({ length: 4 }).map((_, index) => (
            <CarouselItem key={`skeleton-${index}`} className="pl-4 md:basis-1/2 lg:basis-1/3 xl:basis-1/4">
              <div className="border rounded-lg p-4 h-[320px]">
                <Skeleton className="w-full h-48 mb-4" />
                <Skeleton className="h-4 w-3/4 mb-2" />
                <Skeleton className="h-3 w-1/2 mb-3" />
                <div className="flex gap-2">
                  <Skeleton className="h-6 w-16" />
                  <Skeleton className="h-6 w-20" />
                </div>
              </div>
            </CarouselItem>
          ))
        ) : recipes.length > 0 ? (
          recipes.map((recipe) => (
            <CarouselItem key={recipe.id} className="pl-4 md:basis-1/2 lg:basis-1/3 xl:basis-1/4">
              <RecipeCard recipe={recipe} showAddToMenu={false} />
            </CarouselItem>
          ))
        ) : (
          <CarouselItem className="pl-4">
            <div className="border rounded-lg p-4 h-full flex items-center justify-center">
              <p className="text-gray-500">No hay recetas disponibles</p>
            </div>
          </CarouselItem>
        )}
      </CarouselContent>
      <CarouselPrevious className="left-0 -translate-x-1/2" />
      <CarouselNext className="right-0 translate-x-1/2" />
    </Carousel>
  </div>
);

export default ExploreSection;
